import emailConfirmationPageRoute from 'app/(auth)/emailConfirmation';
import loginPageRoute from 'app/(auth)/login';
import oauthRedirectRoute from 'app/(auth)/oauth2/redirect';
import oauthStartFinalizeQboRoute from 'app/(auth)/oauth2/startFinalizeQbo';
import registerPageRoute from 'app/(auth)/register';
import resetPassVerifyEmailPageRoute from 'app/(auth)/resetPassVerifyEmail';
import resetPasswordPageRoute from 'app/(auth)/resetPassword';
import signInWithDisconnectRoute from 'app/(auth)/signInWith/disconnect';
import signInWithStartRoute from 'app/(auth)/signInWith/start';
import verifyEmailPageRoute from 'app/(auth)/verifyEmail';
import xeroSignInRoute from 'app/(auth)/xeroSignIn';
import amaxPaymentFail from 'app/(public)/amaxPayment/fail';
import amaxPaymentSuccess from 'app/(public)/amaxPayment/success';
import connectBankAccountFail from 'app/(public)/connectBankAccount/fail';
import connectBankAccountSuccess from 'app/(public)/connectBankAccount/success';
import customerDecisionRoute from 'app/(public)/customerDecision';
import mobilePageRoute from 'app/(public)/mobile';
import receiptBankAuth from 'app/(public)/receiptBank/auth';
import reconnectBankAccountSuccess from 'app/(public)/reconnectBankAccount/success';
import walletsKycDetailsRoute from 'app/(public)/wallets/kycDetails';
import walletsKycDetailsSubmittedRoute from 'app/(public)/wallets/kycDetails/submitted';
import walletsKycDetailsUnavailableRoute from 'app/(public)/wallets/kycDetails/unavailable';
import acceptInvitationRoute, { acceptInvitationOldRouteRedirect } from 'app/(workspace)/[companyId]/acceptInvitation';
import bankAccountsRoute from 'app/(workspace)/[companyId]/bankAccounts';
import budgetsRoute from 'app/(workspace)/[companyId]/budgets';
import companyInfoRoute from 'app/(workspace)/[companyId]/companyInfo';
import contactPaymentDetailsRoute from 'app/(workspace)/[companyId]/contactPaymentDetails';
import customFieldsRoute from 'app/(workspace)/[companyId]/customFields';
import gettingStartedRoute from 'app/(workspace)/[companyId]/gettingStarted';
import reportsRoute from 'app/(workspace)/[companyId]/reports';
import reportsLineitemRoute from 'app/(workspace)/[companyId]/reports/lineItem';
import reportLineItemPageRoute from 'app/(workspace)/[companyId]/reports/lineItem/[reportId]';
import reportsRequestRoute from 'app/(workspace)/[companyId]/reports/request';
import reportPageRoute from 'app/(workspace)/[companyId]/reports/request/[reportId]';
import usersRoute from 'app/(workspace)/[companyId]/users';
import walletsRoute from 'app/(workspace)/[companyId]/wallets';
import walletsKycRoute from 'app/(workspace)/[companyId]/wallets/kyc';
import walletsKycWizardRoute from 'app/(workspace)/[companyId]/wallets/kyc/wizard';
import workflowsRoute from 'app/(workspace)/[companyId]/workflows';
import workflowsIdRoute from 'app/(workspace)/[companyId]/workflows/[workflowId]';
import workflowsNewRoute from 'app/(workspace)/[companyId]/workflows/new';
import awxOauthRedirRoute from 'app/(workspace)/awxOauthRedir';
import completeSetupRoute from 'app/(workspace)/completeSetup';
import customerFeedbackRoute from 'app/(workspace)/customerFeedback';
import customerFeedbackBoardIdRoute from 'app/(workspace)/customerFeedback/[boardId]';
import loginWithPasskeyRoute from 'app/(workspace)/loginWithPasskey';
import noCompaniesRoute from 'app/(workspace)/noCompanies';
import profileSetupEmail from 'app/(workspace)/profileSetup/email';
import profileSetupSso from 'app/(workspace)/profileSetup/sso';
import signUpWithFinalizeRoute from 'app/(workspace)/signUpWith/finalize';
import slackAuthConnectPage from 'app/(workspace)/slack/auth/connect';
import slackAuthConnectUserPage from 'app/(workspace)/slack/auth/connectUser';
import slackAuthInstallPage from 'app/(workspace)/slack/auth/install';
import twoFaHardEnforcementRoute from 'app/(workspace)/twoFaHardEnforcement';
import globalRoutes from 'pages/@global/routes';
import requestFormRoutes from 'pages/requestForm/routes';
import requestListRoutes from 'pages/requestList/routes';
import twoFaRoutes from 'pages/twoFaHardEnforcement/routes';

/**
 * All auth routes
 */
export const authRoutes = [oauthStartFinalizeQboRoute, oauthRedirectRoute, ...twoFaRoutes];

/**
 * All auth redesigned routes
 */
export const authRoutesRedesign = [
    loginPageRoute,
    registerPageRoute,
    emailConfirmationPageRoute,
    resetPasswordPageRoute,
    resetPassVerifyEmailPageRoute,
    verifyEmailPageRoute,
    mobilePageRoute,
    signInWithStartRoute,
    signInWithDisconnectRoute,
    xeroSignInRoute,
];

/**
 * All unauthorized routes
 */
export const publicRoutes = [reconnectBankAccountSuccess, amaxPaymentFail, amaxPaymentSuccess];

/**
 * All unauthorized redesigned routes
 */
export const publicRoutesRedesign = [
    customerDecisionRoute,
    connectBankAccountSuccess,
    connectBankAccountFail,
    reconnectBankAccountSuccess,
    amaxPaymentFail,
    amaxPaymentSuccess,
    receiptBankAuth,
];

/**
 * All workspace routes
 */
export const workspaceRoutes = [
    ...globalRoutes,
    ...requestFormRoutes,
    ...requestListRoutes,
    bankAccountsRoute,
    contactPaymentDetailsRoute,
    gettingStartedRoute,
];

/**
 * All workspace redesigned routes
 */
export const workspaceRoutesRedesign = [
    budgetsRoute,
    workflowsRoute,
    workflowsNewRoute,
    workflowsIdRoute,
    usersRoute,
    companyInfoRoute,
    reportsRoute,
    reportsRequestRoute,
    reportsLineitemRoute,
    reportPageRoute,
    reportLineItemPageRoute,
    customerFeedbackRoute,
    customerFeedbackBoardIdRoute,
    noCompaniesRoute,
    completeSetupRoute,
    customFieldsRoute,
    walletsRoute,
    walletsKycRoute,
    awxOauthRedirRoute,
];

export const simpleLayoutRoutes = [
    profileSetupEmail,
    profileSetupSso,
    slackAuthConnectPage,
    slackAuthConnectUserPage,
    slackAuthInstallPage,
    twoFaHardEnforcementRoute,
    walletsKycWizardRoute,
    walletsKycDetailsRoute,
    walletsKycDetailsSubmittedRoute,
    walletsKycDetailsUnavailableRoute,
    loginWithPasskeyRoute,
    signUpWithFinalizeRoute,
    acceptInvitationRoute,
    acceptInvitationOldRouteRedirect,
];
